import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { Outlet } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { ClubLayout } from '@sorare/gameplay/src/components/profile/ClubLayout';

import type {
  FootballProHistoryLayoutQuery,
  FootballProHistoryLayoutQueryVariables,
} from './__generated__/layout.graphql';
import type { LayoutParams } from './__generated__/routeParams';

const PRO_HISTORY_LAYOUT_QUERY = gql`
  query FootballProHistoryLayoutQuery($slug: String!) {
    user(slug: $slug) {
      slug
    }
  }
` as TypedDocumentNode<
  FootballProHistoryLayoutQuery,
  FootballProHistoryLayoutQueryVariables
>;

const HistoryLayout = () => {
  const { slug } = useTypedParams<LayoutParams>();

  const { data } = useQuery(PRO_HISTORY_LAYOUT_QUERY, {
    variables: {
      slug,
    },
  });

  const { user } = data || {};

  if (!user) {
    return null;
  }

  return (
    <ClubLayout home>
      <Outlet />
    </ClubLayout>
  );
};

export default HistoryLayout;
